import axios from 'axios'
import { clone } from '@/util/libUtil.js'


const state = ()=>({
    isOpenDialog: false,
    isEditableForm: false,
    formType: '',
    editingId: '',
    Name: '',
    Operator: '',
    Tramo: '',
    Price: '',
    Upfront: 0,
    IsActive: false,
    upfront_history: [],
    insurances: [],
    paths:{
        insurancePath: '/api/servicios/seguros/',
    }
})

const initialState = {...state()}

const mutations = {
    resetStore: (state) => {
        let copy = [...state.insurances]
        initialState.insurances = copy
        Object.assign(state, initialState)
    },
    upfront_history: (state, val) => {
        state.upfront_history = clone(val);
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    Name: (state, val) => {
        state.Name = val
    },
    Operator: (state, val) => {
        state.Operator = val
    },
    Price: (state, val) => {
        state.Price = val
    },
    Upfront: (state, val) => {
        state.Upfront = val
    },
    Tramo: (state, val) => {
        state.Tramo = val
    },
    IsActive: (state, val) => {
        state.IsActive = val
    },
    insurances: (state, val) => {
        state.insurances = clone(val)
    },
}

const actions = {
    async getInsurances({dispatch, getters, state, commit}) {
        try{
            // commit('ManagementBase/loadingItems', true, {root: true})
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.insurancePath))
            commit('insurances', resp.data)
            // commit('ManagementBase/loadingItems', false, {root: true})

            // dispatch('util/showStatusSnackBar', {
            //     statusType: 'success',
            //     message: 'Seguros Cargadas Correctamente'
            // }, {root: true})
        }
        catch{
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido Seguros'
            }, {root: true})
        }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.insurancePath) + item.id )
            dispatch('getInsurances')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, {root: true})
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, {root: true})
        }
    },
    async addInsurance({ state, getters, dispatch }) {
        let insurance = {
            'name' : state.Name,
            'operator' : state.Operator,
            'is_active' : state.IsActive,
            'price' : state.Price,
            'tramo' : state.Tramo,
        }

        try {
            await axios.post(getters.getEndpointFromPath(state.paths.insurancePath), insurance)
            dispatch('getInsurances')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Seguro Añadido Correctamente',
            }, {root: true})
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Añadir Seguro',
            }, {root: true})
        }
    },
    async editInsurance({ state, getters, dispatch }) {
        let insurance = {
            'name' : state.Name,
            'operator' : state.Operator,
            'is_active' : state.IsActive,
            'price' : state.Price,
            'tramo' : state.Tramo,
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.insurancePath) + state.editingId + '/', insurance)
            dispatch('getInsurances')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Seguro Actualizado Correctamente',
            }, {root: true})
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar Seguro',
            }, {root: true})
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}